<template>
  <div class="testing-task-info">
    <div class="back" @click="back">
      <a-button type="primary">
        <i class="iconfont icon-fanhuiicon mr5"></i>返回
      </a-button>
    </div>
    <div class="task_main">
      <div class="drawer_title">车辆信息</div>
      <div class="mt12">
        <!-- 车辆信息选择区域 -->
        <div class="vehicle-info-area" @click="openVehicleModal">
          <template v-if="selectedVehicle">
            <a-descriptions :column="2" bordered>
              <a-descriptions-item label="车辆识别代码">{{ selectedVehicle.vin }}</a-descriptions-item>
              <a-descriptions-item label="车辆类型">{{ selectedVehicle.vehicleTypeName }}</a-descriptions-item>
              <a-descriptions-item label="车身颜色">{{ selectedVehicle.color }}</a-descriptions-item>
              <a-descriptions-item label="动力形式">{{ selectedVehicle.powerType }}</a-descriptions-item>
              <a-descriptions-item label="生产企业">{{ selectedVehicle.manufacturer }}</a-descriptions-item>
              <a-descriptions-item label="测试有效期">{{ selectedVehicle.startDate }} 至 {{ selectedVehicle.endDate }}</a-descriptions-item>
            </a-descriptions>
          </template>
          <template v-else>
            <div class="empty-vehicle-info">
              <i class="iconfont icon-empty"></i>
              <span>请选择测试车辆</span>
            </div>
          </template>
        </div>
      </div>
      <div class="drawer_title mt12">测试牌照</div>
      <div class="mt12 test-license-info">
        <div class="license-content">
          <div class="license-row">
            <div class="license-label">测试牌照：</div>
            <div class="license-value">{{ selectedVehicle?.licenceNo || '-' }}</div>
          </div>
          <div class="license-row">
            <div class="license-label">牌照有效期：</div>
            <div class="license-value">{{ (selectedVehicle?.licenceStartDate || '-') + ' - ' + (selectedVehicle?.licenceEndDate || '-') }}</div>
          </div>
        </div>
        <div class="license-actions">
          <a-button type="primary" @click="handleLicenseAction" :disabled="!selectedVehicle">
            {{ selectedVehicle?.licenceNo ? '更新测试牌照' : '添加测试牌照' }}
          </a-button>
        </div>
      </div>
      <div class="drawer_title mt12">测试信息</div>
      <div class="mt12 test-info-container">
        <!-- 第一部分：测试区域选择 -->
        <div class="test-section">
          <div class="section-title">已申请测试区域</div>
          <div class="test-area-cards">
            <template v-if="selectedVehicle">
              <div 
                v-for="area in applicationAreas"
                :key="area.areaId"
                class="test-area-card"
                :class="{ 'selected': selectedArea === area }"
                @click="selectedArea = area"
              >
                <div class="test-area-content">
                  <div class="test-area-name">{{ area.areaName }}</div>
                  <div class="test-area-period">测试有效期：{{ area.startDate }} 至 {{ area.endDate }}</div>
                </div>
              </div>
              <div v-if="applicationAreas.length === 0" class="empty-route-info"><span>该车辆暂无已申请的测试区域</span></div>
            </template>
            <div v-else class="empty-route-info"><span>请先选择测试车辆</span></div>
          </div>
        </div>
        
        <!-- 第二部分：测试路线选择 -->
        <div class="test-section">
          <div class="section-title">测试路线</div>
          <div class="test-routes-container">
            <template v-if="selectedVehicle">
              <a-checkbox-group v-model:value="selectedRoutes" v-if="selectedArea">
                <div class="routes-list">
                  <a-checkbox 
                    v-for="(route, index) in getSelectedAreaRoutes()" 
                    :key="index" 
                    :value="route.routeId"
                  >
                    {{ route.routeName }}
                  </a-checkbox>
                </div>
              </a-checkbox-group>
              <div class="empty-route-info" v-else>
                <span>请先选择测试区域</span>
              </div>
            </template>
            <div class="empty-route-info" v-else>
              <span>请先选择测试车辆</span>
            </div>
          </div>
        </div>
        
        <!-- 第三部分：测试时间选择 -->
        <div class="test-section">
          <div class="section-title">测试时间</div>
          <div class="test-time-container">
            <div class="time-item">
              <label class="time-label">开始时间：</label>
              <a-date-picker 
                v-model:value="testTime.startTime" 
                :show-time="{ format: 'HH:mm', minuteStep: 1 }" 
                format="YYYY-MM-DD HH:mm:ss" 
                value-format="YYYY-MM-DD HH:mm:ss" 
                style="width: 200px;" 
                placeholder="选择开始时间"
              />
            </div>
            <div class="time-item">
              <label class="time-label">结束时间：</label>
              <a-date-picker 
                v-model:value="testTime.endTime" 
                :show-time="{ format: 'HH:mm', minuteStep: 1 }" 
                format="YYYY-MM-DD HH:mm:ss" 
                value-format="YYYY-MM-DD HH:mm:ss" 
                style="width: 200px;" 
                placeholder="选择结束时间"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="mt24 botmBtn">
        <a-button type="primary" ghost @click="cancel">取消</a-button>
        <a-button type="primary" class="ml60" @click="submit">确定</a-button>
      </div>

    </div>
    <!-- 车辆选择弹框 -->
    <a-modal
        v-model:visible="showVehicleModal"
        title="选择测试车辆"
        width="1000px"
        @ok="handleVehicleOk"
        @cancel="handleVehicleCancel"
        @open="getVehicleList"
    >
      <div class="vehicle-modal-content">
        <!-- 搜索区域 -->
        <div class="search-container">
          <div class="search-item">
            <label>测试牌照</label>
            <a-input class="search-input" placeholder="请输入" v-model:value="vehicleQuery.licenceNo"></a-input>
          </div>
          <div class="search-item">
            <label>车架号</label>
            <a-input class="search-input" placeholder="请输入" v-model:value="vehicleQuery.vin"></a-input>
          </div>
          <div class="search-actions">
            <a-button type="primary" ghost @click="searchVehicles">查询</a-button>
            <a-button type="primary" ghost @click="resetVehicleQuery">重置</a-button>
          </div>
        </div>

        <!-- 车辆列表 -->
        <a-table
            :columns="vehicleColumns"
            :row-key="(record) => record.id"
            size="middle"
            class="mt23"
            :scroll="{ x: 1500, y: 'auto' }"
            :data-source="vehicleDataSource"
            :pagination="vehiclePagination"
            :row-selection="{ type: 'radio', selectedRowKeys: selectedVehicleKeys, onChange: onSelectChange }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'testingTime'">
              {{ record.startDate }} 至 {{ record.endDate }}
            </template>
          </template>
        </a-table>
      </div>
    </a-modal>

    <!-- 测试牌照弹框 -->
    <a-modal
        v-model:open="showLicenseModal"
        :title="licenseModalTitle"
        @ok="handleLicenseOk"
        @cancel="handleLicenseCancel"
        width="700px"
    >
      <div class="license-form">
        <div class="form-item">
          <label class="form-label">测试牌照：</label>
          <a-input v-model:value="licenseForm.licenceNo" placeholder="请输入测试牌照" style="width: 26%;" />
        </div>
        <div class="form-item">
          <label class="form-label">牌照有效期：</label>
          <div class="date-range">
            <a-date-picker
                v-model:value="licenseForm.licenceStartDate"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                placeholder="开始时间"
                style="width: 35%; margin-right: 3%;"
            />
            <span style="margin-right: 3%;">至</span>
            <a-date-picker
                v-model:value="licenseForm.licenceEndDate"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                placeholder="结束时间"
                style="width: 35%;"
            />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { testingVehiclePages } from "@/api/testing/vehicle";
import { message } from 'ant-design-vue'
import useAppStore from "@/store/modules/app";
import useUserStore from '@/store/modules/user'
import { getVehicleApplicationAreaRoutes } from '@/api/application/applicationRoutes'
import { createTestingTask } from '@/api/testing/task'
const appStore = useAppStore();
const userStore = useUserStore();

const router = useRouter()
const route = useRoute()

// 车辆选择相关
const showVehicleModal = ref(false)
const selectedVehicle = ref(null)
const selectedVehicleKeys = ref([])
const vehicleDataSource = ref([])

// 测试牌照弹框相关
const showLicenseModal = ref(false)
const licenseModalTitle = ref('')
const licenseForm = ref({
  licenseId: null,
  licenceNo: '',
  licenceStartDate: null,
  licenceEndDate: null
})

// 测试区域数据
const applicationAreas = ref([])

// 选中的测试区域
const selectedArea = ref(null)

// 选中的测试路线
const selectedRoutes = ref([])

// 测试时间
const testTime = ref({
  startTime: null,
  endTime: null
})

// 获取选中测试区域的路线列表
const getSelectedAreaRoutes = () => {
  return selectedArea.value ? selectedArea.value.routes : []
}

// 车辆查询参数
const vehicleQuery = ref({
  deptName: "",
  vin: "",
  licenceNo: ""
})

// 车辆列表分页
const vehiclePagination = ref({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (vehiclePagination.value.pageSize = pageSize),
  onChange: (page, pageSize) => {
    vehiclePagination.value.current = page
    getVehicleList()
  },
  showSizeChange: (current, size) => {
    vehiclePagination.value.pageSize = size
    getVehicleList()
  }
})

// 车辆列表列定义
const vehicleColumns = ref([
  {
    title: "车辆识别代码",
    key: "vin",
    dataIndex: "vin",
    width: 150,
  },
  {
    title: "车辆类型",
    key: "vehicleTypeName",
    dataIndex: "vehicleTypeName",
    width: 120,
  },
  {
    title: "测试牌照",
    key: "licenceNo",
    dataIndex: "licenceNo",
    width: 120,
  },
  {
    title: "测试有效期",
    key: "testingTime",
    dataIndex: "testingTime",
    width: 220,
  },
  {
    title: "车身颜色",
    key: "color",
    dataIndex: "color",
    width: 80,
  },
  {
    title: "动力形式",
    key: "powerType",
    dataIndex: "powerType",
    width: 100,
  },
  {
    title: "生产企业",
    dataIndex: "manufacturer",
    key: "manufacturer",
    width: 180,
  }
])

// 获取车辆列表
const getVehicleList = () => {
  const data = {
    pageIndex: vehiclePagination.value.current,
    pageSize: vehiclePagination.value.pageSize,
    conditionMap: { ...vehicleQuery.value, deptIdStr: userStore.deptId, applicationStatus: '5' },
  }
  // 使用车辆查询API
  testingVehiclePages(data).then((res) => {
    if (res.data && res.data.records) {
      vehicleDataSource.value = res.data.records || []
      vehiclePagination.value.total = res.data.total
    }
  })
}

// 搜索车辆
const searchVehicles = () => {
  vehiclePagination.value.current = 1
  getVehicleList()
}

// 重置车辆查询
const resetVehicleQuery = () => {
  vehicleQuery.value = {
    deptName: "",
    vin: "",
    licenceNo: ""
  }
  vehiclePagination.value.current = 1
  getVehicleList()
}

// 车辆选择变化
const onSelectChange = (selectedRowKeys, selectedRows) => {
  selectedVehicleKeys.value = selectedRowKeys
  if (selectedRows.length > 0) {
    selectedVehicle.value = selectedRows[0]
  }
}

// 打开车辆选择弹框
const openVehicleModal = () => {
  showVehicleModal.value = true
  getVehicleList()
}

// 确定选择车辆
const handleVehicleOk = () => {
  if (selectedVehicle.value) {
    // 调用接口获取该车辆可选择的测试区域及路线信息
    getVehicleApplicationAreaRoutes(selectedVehicle.value.id).then(res => {
      if (res.code === 200) {
        // 更新测试区域数据
        applicationAreas.value = res.data
        // 重置选中的测试区域和路线
        selectedArea.value = null
        selectedRoutes.value = []
        // 如果只有一个测试区域，自动选中它
        if (applicationAreas.value.length === 1) {
          selectedArea.value = applicationAreas.value[0]
        }
        // 关闭车辆选择弹框
        showVehicleModal.value = false
      } else {
        message.error('获取测试区域及路线失败：' + res.message)
      }
    }).catch(err => {
      console.error('获取测试区域及路线失败：', err)
      message.error('获取测试区域及路线失败，请稍后重试')
    })
  } else {
    message.warning("请选择一辆测试车辆")
  }
}

// 取消选择车辆
const handleVehicleCancel = () => {
  showVehicleModal.value = false
}

// 处理测试牌照操作（添加或更新）
const handleLicenseAction = () => {
  if (selectedVehicle.value?.licenseId) {
    // 更新测试牌照
    licenseModalTitle.value = '更新测试牌照'
    // 填充现有数据
    licenseForm.value = {
      licenseId: selectedVehicle.value.licenseId || null,
      licenceNo: selectedVehicle.value.licenceNo || null,
      licenceStartDate: selectedVehicle.value.licenceStartDate || null,
      licenceEndDate: selectedVehicle.value.licenceEndDate || null
    }
  } else {
    // 添加测试牌照
    licenseModalTitle.value = '添加测试牌照'
    // 清空表单
    licenseForm.value = {
      licenseId: null,
      licenceNo: '',
      licenceStartDate: null,
      licenceEndDate: null
    }
  }
  // 打开弹框
showLicenseModal.value = true
}

// 处理测试牌照弹框的确定按钮
const handleLicenseOk = () => {
  // 表单验证
  if (!licenseForm.value.licenceNo) {
    message.warning('请输入测试牌照')
    return
  }
  if (!licenseForm.value.licenceStartDate) {
    message.warning('请选择开始日期')
    return
  }
  if (!licenseForm.value.licenceEndDate) {
    message.warning('请选择结束日期')
    return
  }
  if (licenseForm.value.licenceStartDate > licenseForm.value.licenceEndDate) {
    message.warning('开始日期不能晚于结束日期')
    return
  }

  // 更新selectedVehicle对象
  selectedVehicle.value = {
    ...selectedVehicle.value,
    licenseId: licenseForm.value.licenseId,
    licenceNo: licenseForm.value.licenceNo,
    licenceStartDate: licenseForm.value.licenceStartDate,
    licenceEndDate: licenseForm.value.licenceEndDate
  }

  showLicenseModal.value = false
  message.success(licenseModalTitle.value === '添加测试牌照' ? '测试牌照添加成功' : '测试牌照更新成功')
}

// 处理测试牌照弹框的取消按钮
const handleLicenseCancel = () => {
  showLicenseModal.value = false
}

const back = () => {
  router.push('/testManage/task')
}

const cancel = () => {
  router.push('/testManage/task')
}

const submit = () => {
  if (!selectedVehicle.value) {
    message.warning("请选择测试车辆");
    return;
  }
  const newTask = {
    vehicleId: selectedVehicle.value.id,
    licenseId: licenseForm.value.licenseId?licenseForm.value.licenseId:'0',
    licenceNo: licenseForm.value.licenceNo,
    licenceStartDate: licenseForm.value.licenceStartDate,
    licenceEndDate: licenseForm.value.licenceEndDate,
    applicationId: selectedArea.value?.applicationId,
    areaId: selectedArea.value?.areaId,
    routeIds: selectedRoutes.value,
    startTime: testTime.value.startTime,
    endTime: testTime.value.endTime
  };
  console.log("newTask", newTask);
  createTestingTask(newTask).then(res => {
    if (res.code === 200 && res.data){
      message.success("任务添加成功");
      router.push('/testManage/task')
    }else {
      message.error(res.message);
    }
  })
}

</script>
<style lang="less" scoped>
.testing-task-info {
  padding: 20px;
  background-color: #ffffff;
  .back {
    position: fixed;
    top: 93px;
    right: 50px
  }

  .task_main {
    width: 66%;
    margin: 0 auto;

    .drawer_title {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #1D2129;
      position: relative;

      &::before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 12px;
        background: #1E8EF2;
        border-radius: 10px;
        position: absolute;
        top: 2px;
        left: -12px;
      }
    }

    // 车辆信息区域样式
    .vehicle-info-area {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      padding: 20px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }

      // 空车辆信息样式
      .empty-vehicle-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 0;
        color: #8c8c8c;

        i {
          font-size: 48px;
          margin-bottom: 16px;
        }

        span {
          font-size: 16px;
        }
      }
    }
  }
}

.vehicle-modal-content {

  .search-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    width: 100%;
    padding: 10px 0;
    .search-item {
      display: flex;
      align-items: center;
      margin-right: 30px;
      white-space: nowrap;

      label {
        margin-right: 8px;
        font-weight: 400;
        color: #333;
      }

      .search-input {
        width: 230px;
        height: 32px;
        margin: 0;
        vertical-align: middle;
      }
    }
    .search-actions {
      display: flex;
      align-items: center;
      margin-left: auto;

      .ant-btn {
        height: 32px;
        margin-left: 16px;
        vertical-align: middle;
      }
      .ant-btn:first-child {
        margin-left: 0;
      }
    }
  }
}

.mt12 {
  margin-top: 12px;
}

.mt50 {
  margin-top: 50px;
}

.botmBtn {
  text-align: center;

  .ant-btn {
    margin: 0 30px;
  }
}

/deep/.ant-input-disabled,
.ant-input[disabled] {
  background: #ddd;
}

/deep/.ant-picker.ant-picker-disabled {
  background: #ddd;
}

// 表格列宽调整
:deep(.ant-table) {
  .ant-table-cell {
    white-space: nowrap;
  }
}

// 调整车辆信息表格的padding
:deep(.ant-descriptions-bordered) {
  .ant-descriptions-row {
    > td, > th {
      padding: 8px 12px;
    }
  }
}

// 测试牌照弹框样式
.license-form {
  padding: 20px 0;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.form-label {
  width: 100px;
  text-align: right;
  margin-right: 16px;
  font-weight: 500;
}

.date-range {
  display: flex;
  align-items: center;
  width: 75%;
}

// 测试牌照信息区域样式
.test-license-info {
  position: relative;
  padding: 16px;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding-bottom: 48px; /* 为右下角按钮留出空间 */

  .license-content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .license-row {
      display: flex;
      align-items: center;
      margin-right: 32px;
      padding-left: 12px;

      .license-label {
        width: 150px;
        font-weight: 500;
        color: #666;
        text-align: left;
        padding-right: 16px;
        font-size: 14px;
        line-height: 22px;
      }

        .license-value {
          color: #333;
          font-size: 14px;
          line-height: 22px;
          min-width: 120px;
        }
    }
  }

  .license-actions {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
}

// 测试区域卡片样式
.test-area-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
  margin-top: 7px;
}

.test-area-card {
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  box-sizing: border-box;
  /* 移除固定最小高度，让卡片高度自适应内容 */
}

.test-area-card:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
}

.test-area-card.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

// 测试信息三部分布局样式
.test-info-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.test-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 20px;
}

.section-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

// 测试路线选择区域样式
.test-routes-container {
  padding: 8px 0;
}

.routes-list {
  display: flex;
  flex-direction: column;
  padding: 3px 0;
}

.routes-list :deep(.ant-checkbox-wrapper) {
  margin-right: 0;
  margin-bottom: 0;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s;
  width: 100%;
  font-size: 14px;
  font-weight: normal;
}

.routes-list :deep(.ant-checkbox-wrapper:hover) {
  background-color: #f5f7fa;
}

.empty-route-info {
  padding: 12px 0;
  color: #999;
  font-style: normal;
}

// 测试时间选择区域样式
.test-time-container {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  align-items: center;
}

.time-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 7px;
}

.time-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  width: 80px;
  text-align: right;
}

.test-area-card .test-area-period {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.test-area-card .test-area-content {
  flex: 1;
}

.test-area-card .test-area-name {
  font-size: 16px;
  font-weight: 500;
  color: #1d2129;
  margin-bottom: 12px;
}
</style>
